import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import manage from '@/components/manage'
import mobile from '@/components/mobile'
import content from '@/components/Content'
import app from "@/components/app"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      // 404页面
      path: "*",
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/manage',
      name: 'manage',
      component: manage,
      children: [
        {
          path: '/manage/dataQuery',
          name: 'Content',
          component: content
        },
        {
          path: '/manage/app',
          name: 'app',
          component: app
        }
      ]
    },
    {
      path: '/m/:id',
      name: 'mobile',
      component: mobile
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js